<template>
  <div class="content">
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60px"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="业务标题"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="processInstanceId"
        label="流程编号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="processDefinitionName"
        label="流程名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="startUserName"
        label="发起人"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="startTime"
        label="开始时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="endTime"
        label="结束时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="当前环节"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            plain
            icon="el-icon-coordinate"
            @click="editRow(scope.row)"
            v-hasPermi="['personalOffice:myMission:transaction']"
            >办理</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { workflowTask } from "@/api/api.js"; //流程实例分页查询
export default {
  data() {
    return {
      queryParams: {},
      tableData: [],
      page: 1,
      pageSize: 20,
      total: 0,
    };
  },
  methods: {
    // 获取列表的数据
    initData() {
      let params = {
        model: {
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      workflowTask(params).then((res) => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    // 办理
    editRow(row) {
      let processDefinitionId = row.processDefinitionId;
      if(processDefinitionId.includes("customer")){
        this.$router.push({path: "/procedure/flowCustomerInformation",query: {id: row.id, processId: row.processInstanceId}});
      }
      if(processDefinitionId.includes("ShipmentRequest")){
        this.$router.push({path: "/procedure/flowShipment",query: {id: row.id, processId: row.processInstanceId}});
      }
    },
    // 搜索
    search() {
      (this.page = 1), this.initData();
    },
  },
  mounted() {
    this.initData();
  },
  created() {},
};
</script>
<style scoped lang="less">
</style>


